import { FaEdit, FaFilePdf, FaTrash } from "react-icons/fa"; // Import icons
import React, { useState } from "react";
import { HiOutlinePencil, HiOutlineTrash } from "react-icons/hi";

const MobileOrderCard = ({
  order,
  getActionClass,
  openEditModal,
  handleDeleteOrder,
  handleUpdateStatus,
}) => {
  // Track if the order"s items are expanded or collapsed
  const [isExpanded, setIsExpanded] = useState(false);

  const items = Array.isArray(order.items) ? order.items : [];

  // Toggle the expanded state of the items section
  const toggleExpandCollapse = () => {
    setIsExpanded((prevState) => !prevState);
  };

  return (
    <div className="bg-gray-50 rounded-lg p-2 border   space-y-1 border-gray-300 mb-2 shadow-md">
      {/* Order details */}
      <div className="flex justify-between text-xs text-gray-700">
        <div className="font-semibold">Order ID</div>
        <span className="font-semibold text-indigo-600 bg-blue-100 px-2 uppercase py-1 rounded-md">
          {order._id.slice(-5)}
        </span>
      </div>
      <div className="flex justify-between text-xs text-gray-700">
        <div className="font-semibold">Firm Name</div>
        <div>{order.createdBy ? order.createdBy.firmName : ""}</div>
      </div>
      <div className="flex justify-between text-xs text-gray-700">
        <div className="font-semibold">Created By</div>
        <div>{order.createdBy ? order.createdBy.name : "Unknown"}</div>
      </div>
      <div className="flex justify-between text-xs text-gray-700">
        <div className="font-semibold">Assigned To</div>
        <div>{order.assignedTo ? order.assignedTo.name : "Not Assigned"}</div>
      </div>
      <div className="flex justify-between text-xs text-gray-700">
        <div className="font-semibold">Pdf File</div>
        <FaFilePdf
          size={16}
          className="text-red-600 hover:text-red-800 cursor-pointer"
        />
      </div>
      <div className="flex justify-between text-xs text-gray-700">
        <div className="font-semibold">Status</div>
        <div>
          <span
            className={`px-2 py-0.5 rounded-md text-[10px] ${getActionClass(
              order.status
            )}`}
          >
            {order.status}
          </span>
        </div>
      </div>

      {/* Expanded items section */}
      {isExpanded && (
        <div className="mt-4">
          {items.length > 0 ? (
            items.map((item, index) => (
              <div
                key={item._id}
                className="mb-2 p-2 border border-gray-200 bg-white rounded-lg shadow-sm"
              >
                <p className="text-xs font-medium text-red-600">
                  Item {index + 1}
                </p>
                <div className="flex justify-between text-xs text-gray-700">
                  <div className="font-semibold">Category</div>
                  <div>{item.categoryName}</div>
                </div>
                <div className="flex justify-between text-xs text-gray-700">
                  <div className="font-semibold">Item</div>
                  <div>{item.itemName}</div>
                </div>
                <div className="flex justify-between text-xs text-gray-700">
                  <div className="font-semibold">Quantity</div>
                  <div>{item.qty}</div>
                </div>
                <div className="flex justify-between text-xs text-gray-700">
                  <div className="font-semibold">Warehouse Name</div>
                  <div>{item.wareHouseName}</div>
                </div>
                <div className="flex justify-between text-xs text-gray-700">
                  <div className="font-semibold">Price</div>
                  <div>{`${item.price}`}</div>
                </div>
                <div className="flex justify-between text-xs text-gray-700">
                  <div className="font-semibold">Total Amount</div>
                  <div>{`${item.totalAmount}`}</div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-gray-500 text-xs text-center">
              No items available.
            </p>
          )}
        </div>
      )}

      {/* Edit and Delete icons */}
      <div className="flex justify-end mt-4 gap-4">
        {order.totalItemAmount > 0 ? (
          <select
            className="bg-gray-200 border border-gray-300 rounded px-2 py-0.5 text-xs hover:bg-gray-300"
            onChange={(e) => handleUpdateStatus(order._id, e.target.value)}
            value={order.status} // Make sure the current status is selected
          >
            <option value="" disabled>
              Select Status
            </option>
            <option value="Pending">Pending</option>
            <option value="Accept">Accept</option>
            <option value="Reject">Reject</option>
          </select>
        ) : (
          <select
            className="bg-gray-200 border border-gray-300 rounded px-2 py-0.5 text-xs opacity-50 cursor-not-allowed"
            disabled
            value={order.status}
          >
            <option value={order.status} disabled>
              {order.status} (Amount Not Set)
            </option>
          </select>
        )}
        <button
          onClick={toggleExpandCollapse}
          className="bg-blue-500 text-xs hover:bg-blue-700 text-white px-2 py-0.5 rounded-md"
        >
          {isExpanded ? "Collapse Items" : "Expand Items"}
        </button>
        <button
          onClick={() => openEditModal(order)}
          className="text-blue-500 hover:text-blue-700"
        >
          <HiOutlinePencil size={16} /> {/* Edit Icon */}
        </button>
        <button
          onClick={() => handleDeleteOrder(order._id)}
          className="text-red-500 hover:text-red-700"
        >
          <HiOutlineTrash size={16} /> {/* Delete Icon */}
        </button>
      </div>
    </div>
  );
};

export default MobileOrderCard;
